export class proposalData {
    firstName: string = '';
    lastName: string = '';
    mobile: string = '';
    email: string = '';
    sumInsured: string = '';
    title : string = '';
    address1 : string = '';
    dob : string = '';
    // adhaar : string = '';
    pincode : string = '';
    city : string = '';
    state : string = '';
    occupation : string = '';
    nomineeName : string = '';
    nomineeRelation : string = '';
    prospectId : string = '';
    quoteId : string = '';
    premium: any;

    constructor() {
    }
}